import React from 'react';
import Header from '../Header';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Entities } from '../../types/types';
import Link from '@mui/material/Link';

interface NoAccessPageProps {
  entity: Entities;
}

function NoAccessPage(props: NoAccessPageProps) {
  const { entity } = props;
  const hqitUrl: string =
    'https://wework-help.refined.site/portal/161?createRequest=true&portalId=161&requestTypeId=1373';
  const confluenceUrl: string =
    'https://docs.google.com/document/d/1SRE387HHLRExatAsr2kMcf5jNEM2XT7Bpz9NkaKHzTk/edit?tab=t.0#heading=h.6x3xunnb89c';

  return (
    <>
      <Header />
      <Container maxWidth="sm">
        <Box
          sx={{
            height: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h1" color="error">
            403
          </Typography>
          <Typography variant="h3" gutterBottom>
            Forbidden
          </Typography>
          <Typography variant="body1">
            You do not have permission to access the{' '}
            <Typography component="span" fontWeight="bold">
              {entity}
            </Typography>{' '}
            page.
            <Typography component="span" display="block" sx={{ mt: 1 }}>
              To request access, submit an{' '}
              <Link href={hqitUrl} target="_blank" rel="noopener noreferrer" underline="none">
                HQIT ticket
              </Link>
              ,{' '}
              <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                select{' '}
                <Typography component="span" fontWeight="bold">
                  Spacestation / Spaceman (role/s)
                </Typography>
              </Box>{' '}
              in the{' '}
              <Typography component="span" fontWeight="bold">
                Application
              </Typography>{' '}
              field, and specify your desired role in the{' '}
              <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                <Typography component="span" fontWeight="bold">
                  Spaceman role
                </Typography>
              </Box>{' '}
              field (
              <Link href={confluenceUrl} target="_blank" rel="noopener noreferrer" underline="none">
                more info
              </Link>
              ).
            </Typography>
          </Typography>
        </Box>
      </Container>
    </>
  );
}

export default NoAccessPage;
